export default __webpack_public_path__ + "static/media/cronaswap-white.91fbc5fb.svg";